module.exports = __webpack_public_path__ + "img/template_placeholder_yellow@2x.91cf538.png";